import {NgModule} from "@angular/core";
import {LoginModule} from "./login/login.module";
import {DashboardModule} from "./dashboard/dashboard.module";
import {AnimalsModule} from "./animals/animals.module";
import {ContactsModule} from './contact/contacts.module';
import {ChangelogComponent} from './changelog/changelog/changelog.component';
import {SharedModule} from '../shared/shared.module';
import {StatisticsModule} from "./statistics/statistics.module";
import {AnimalShelterModule} from "./animal-shelter/animal-shelter.module";
import {DatePipe} from '@angular/common';

@NgModule({
  imports: [
    SharedModule,
    LoginModule,
    DashboardModule,
    AnimalsModule,
    ContactsModule,
    StatisticsModule,
    AnimalShelterModule
  ],
  exports: [
    ChangelogComponent
  ],
  declarations: [
    ChangelogComponent
  ],
  providers: [
    DatePipe
  ]
})
export class ModulesModule {
}
